<template>
    <div class="home d-flex flex-column">
        <div id="page-content">
            <div class="container text-center">
                <div class="text-left action-text again" @click="again()">
                    <span v-if="stage === 3">{{ againText }}</span>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12">
                        <CarouselPage :stage="stage"></CarouselPage>
                        <div v-if="stage === 3" class="row justify-content-center text-center">
                            <div class="col-10 pb-4 pt-4" style="background: rgba(255,255,255,0.3); backdrop-filter: blur(5px)">
                                <a href="#"
                                   target="_blank"
                                   @click.prevent="$communicator.openDeeplink('open_web', 'https://www.vmt-thueringen.de/tickets/ticketkauf/fairtiq-app')">
                                    {{ $t("moreInformation") }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MJFooter v-if="stage === 3">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-10">
                        <MJButton @click="openDeeplink" :text="btnText" type="primary"></MJButton>
                    </div>
                </div>
                <div class="slider-row row justify-content-center">
                    <div class="col-10">
                        <MJSlider :value="sliderEnabled" v-model="sliderEnabled"></MJSlider>
                    </div>
                </div>
            </div>
        </MJFooter>
        <MJFooter v-else>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-3 prev action-text" @click="prev()">
                        <span v-if="stage > 1">{{ previousText }}</span>
                    </div>
                    <div class="col-6 indicators">
                        <img :src="getCarouselIndicator(1)">
                        <img :src="getCarouselIndicator(2)">
                        <img src="@/assets/carousel_ellipse.svg">
                    </div>
                    <div class="col-3 next action-text" @click="next()">
                        {{ nextText }}
                    </div>
                </div>
            </div>
        </MJFooter>
    </div>
</template>

<script>
// @ is an alias to /src

import MJFooter from "../components/MJFooter";
import CarouselPage from "../components/carousel/CarouselPage";
import MJButton from "../components/MJButton";
import MJSlider from "../components/MJSlider";
import Hammer from "hammerjs";

export default {
    name: 'Home',
    components: {MJButton, MJSlider, MJFooter, CarouselPage},
    mounted() {
        Hammer(document.getElementById("page-content")).on("swipeleft", () => {
            if (this.stage < 3) {
                this.stage++;
            }
        });
        Hammer(document.getElementById("page-content")).on("swiperight", () => {
            if (this.stage > 1) {
                this.stage--;
            }
        });
    },
    data() {
        return {
            stage: 1,
            sliderEnabled: false
        };
    },
    computed: {
        btnText() {
            return this.$i18n.t("footer.button");
        },
        previousText() {
            return this.$i18n.t("carousel.previous.text");
        },
        nextText() {
            return this.$i18n.t("carousel.next.text");
        },
        againText() {
            return this.$i18n.t("carousel.again.text");
        }
    },
    methods: {
        getCarouselIndicator(stage) {
            if (this.stage === stage) {
                return require("@/assets/carousel_rect.svg");
            }
            return require("@/assets/carousel_ellipse.svg");
        },
        async openDeeplink() {
            if (this.sliderEnabled) {
                this.$communicator.disableFairtiqModal();
            }
            switch (await this.$communicator.getDeviceType()) {
                case "Android":
                    this.$communicator.openDeeplink("fairtiq://launch", "https://play.google.com/store/apps/details?id=com.fairtiq.android");
                    break;
                case "iOS":
                    this.$communicator.openDeeplink("fairtiq://launch", "https://apps.apple.com/app/fairtiq/id1094360403");
                    break;
                default:
                    this.$communicator.openDeeplink("fairtiq://launch", "https://fairtiq.com/");
            }
        },
        next() {
            this.stage++;
        },
        prev() {
            if (this.stage > 1) {
                this.stage--;
            }
        },
        again() {
            this.stage = 1;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../scss/color_palette";

.home {
    height: 100%;
}

.indicators {
    text-align: center;

    & > img {
        margin-right: 10px;
        height: 10px;
    }
}

.action-text {
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
}

.prev {
    color: darkblue("50");
}

.next {
    color: darkblue("70");
    text-align: right;
}

.again {
    color: darkblue("70");
    position: absolute;
    top: 3vh;
    left: 3vh;
    z-index: 999;
}
</style>
